module.exports = __webpack_public_path__ + "img/contrast-02.4c872f13.svg";